import { render, staticRenderFns } from "./Categoria2.vue?vue&type=template&id=9567566a&scoped=true&"
import script from "./Categoria2.vue?vue&type=script&lang=js&"
export * from "./Categoria2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9567566a",
  null
  
)

export default component.exports